import { CssBaseline, ThemeProvider } from "@mui/material";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";

import "./global.css";

// Initialize Sentry as early as possible
Sentry.init({
  dsn: import.meta.env.SENTRY_DSN,
  sendDefaultPii: true,
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>,
);

reportWebVitals();
